export default "__VITE_PUBLIC_ASSET__c000e000__"